<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      :visible="visible"
      direction="rtl"
      :size="800"
      show-close
      @close="close"
      :before-close="handleClose"
      append-to-body
    >
      <div>
        <GoodsInfo
          ref="goodsInfoRef"
          v-if="pendingGoodsCode"
          :pendingGoodsCode="pendingGoodsCode"
          :changeCodeList="[pendingGoodsQualityCode]"
          :disabled="disabled"
          :type="'quality'"
          @changeGoods="changeGoods()"
        />
        <QualityUser
          class="mt-2"
          ref="userTable"
          :disabled="disabled"
          :userList="formData.userList"
          :v_createTime="formData.v_createTime"
          :reportDate.sync="formData.reportDate"
          @chooseUserConfirm="chooseUserConfirm"
          @del="del"
        />

        <div class="mt-2">
          <el-form
            ref="formRef"
            :model="formData"
            :rules="rules"
            :disabled="disabled"
            size="small"
            @submit.native.prevent
            label-position="left"
          >
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item
                  :label="$l('form_label_workShiftCode') || '班次'"
                  prop="workShiftCode"
                >
                  <el-radio-group
                    v-model="formData.workShiftCode"
                    size="small"
                    @change="workShiftChange"
                  >
                    <el-radio
                      v-for="(item, key) in mrpWorkShiftData"
                      :key="key"
                      :label="item.value"
                      >{{ item.label }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <el-form
            ref="form"
            :model="formData"
            :rules="rules"
            :disabled="disabled"
            size="small"
            @submit.native.prevent
            label-position="top"
          >
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_checkedQty') || '批次质检数量'"
                  prop="checkedQty"
                >
                  <el-input
                    class="text_color_balck"
                    v-model="formData.checkedQty"
                    :maxlength="500"
                    clearable
                    style="width:100%; "
                    disabled
                  />
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$l('form_label_passQty') || '良品数量'">
                  <el-input
                    class="text_color_green"
                    v-model="formData.passQty"
                    :maxlength="500"
                    clearable
                    style="width:100%; "
                    @change="updateCheckedQty"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_notPassQty') || '不良品数量'"
                >
                  <el-input
                    class="text_color_red"
                    v-model="formData.notPassQty"
                    :maxlength="500"
                    clearable
                    style="width:100%; "
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10"> </el-row>
            <el-row :gutter="10" class="mt-1">
              <div>
                <span class="mr-3" style="font-size: 15px; color: #99A1B7">{{
                  $l('form_label_recheckTime') || '复检日期:'
                }}</span>
                <span style="font-size: 15px; color: #071437">{{
                  formData.recheckTime || '--'
                }}</span>
              </div>
            </el-row>

            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_notPassQty') || '不良品数量'"
                >
                  <el-input
                    class="text_color_balck"
                    v-model="formData.notPassQty"
                    :maxlength="500"
                    clearable
                    style="width:100%; "
                    disabled
                  />
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_recheckPassQty') || '复检良品数量'"
                >
                  <el-input
                    class="text_color_green"
                    v-model="formData.recheckPassQty"
                    :maxlength="500"
                    clearable
                    style="width:100%; "
                    disabled
                  />
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_recheckFailedQty') || '报废数量'"
                >
                  <el-input
                    class="text_color_red"
                    v-model="formData.recheckFailedQty"
                    :maxlength="500"
                    clearable
                    style="width:100%; "
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <ResultRecord
                ref="resultTable"
                :disabled="disabled"
                :issuesList="formData.issuesList"
                :status="formData.status"
                @del="questionDel"
                @update="questionUpdate"
              />
            </el-row>
          </el-form>
        </div>
        <div class="d-flex justify-content-end mb-2 mt-3">
          <el-button
            type="success"
            size="small"
            v-if="!disabled"
            @click="addPassQty()"
            style="width: 90px;"
            >{{ $l('btn_addPassQty') || '良品+1' }}</el-button
          >
          <el-button
            type="danger"
            size="small"
            v-if="!disabled"
            @click="addNotPassQty()"
            style="width: 90px;"
            >{{ $l('btn_addNotPassQty') || '不良品+1' }}</el-button
          >
          <el-button
            type="primary"
            size="small"
            v-if="!disabled"
            @click="save()"
            style="width: 90px;"
            >{{ $l('INDEX.btn_save') || '保存' }}</el-button
          >
        </div>
      </div>
    </el-drawer>
    <chooseQuestion
      v-if="questionDialogVisible"
      :visible.sync="questionDialogVisible"
      :title="'不良问题选择'"
      @confirm="questionConfirm"
      type="checkbox"
    />
  </div>
</template>
<script>
import GoodsInfo from './goods-info'
import ResultRecord from './result-record'
import QualityUser from './quality-user'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ChooseQuestion from './choose-question/dialog.vue'
import { request } from '@/api/service'
import { add } from '@/libs/util.number.js'
export default {
  components: {
    ResultRecord,
    QualityUser,
    ChooseQuestion,
    GoodsInfo,
  },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    pendingGoodsQualityCode: { type: String, default: '' },
    pendingGoodsCode: { type: String, default: '' },
    title: { type: String, default: '' },
  },
  mixins: [EditLoading],
  data() {
    return {
      mrpWorkShiftData: [],
      pdProcessDictStepOptions: [],
      formData: { specName: '' },
      questionDialogVisible: false,
      rules: {
        workShiftCode: [
          {
            required: true,
            message: this.$l('form_label_pl_workShiftCode') || '请选择班次',
            trigger: 'change',
          },
        ],
        checkedQty: [
          {
            required: true,
            message:
              this.$l('form_label_pl_checkedQty') || '请输入批次质检数量',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  async mounted() {
    await this.getData()
    await this.getOptionData()
  },
  computed: {},
  methods: {
    async getData() {
      if (this.pendingGoodsQualityCode) {
        this.$api
          .pendingGoodsQualityDetailApi({
            pendingGoodsQualityCode: this.pendingGoodsQualityCode,
          })
          .then((res) => {
            const resData = res.body || {}
            if (resData.issuesList) {
              resData.issuesList = resData.issuesList.map((item) => {
                if (item.status == 'N') {
                  item.status = null
                  item.statusText = null
                }
                return item
              })
            }
            this.formData = { ...resData }
            this.$refs.goodsInfoRef.getData(this.formData.pendingGoodsCode)
          })
      }
    },
    async getOptionData() {
      request({
        url: '/master/common/dict/biz',
        method: 'POST',
        data: { dictType: 'mrpWorkShift' },
      }).then((res) => {
        const dataList = res.body.data || []
        this.mrpWorkShiftData = dataList.sort((a, b) =>
          a.value.localeCompare(b.value)
        )
      })
    },
    close() {
      if (!this.disabled) this.$emit('reload')
      this.$emit('update:visible', false)
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      const materialBatchResult = await this.$refs.resultTable.validate()
      if (!result || !materialBatchResult) return

      const userCodes = this.formData.userList.map((item) => item.userCode)
      if (!userCodes?.length) {
        this.$message.warning('请选择报工人员')
        return
      }
      if (this.loadingOpen()) return
      const res = await this.$api
        .pendingGoodsQualityEditApi({
          ...this.formData,
          userCodes,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      if (!this.disabled) this.$emit('reload')
    },

    handleClose(done) {
      if (this.disabled) {
        this.close()
        return
      }
      this.$confirm(
        this.$l('INDEX.tips_check_saved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.product_dialog_btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          done()
        })
        .catch(() => {})
    },
    chooseUserConfirm(items) {
      if (!items?.length) return
      const userCodes = this.formData.userList.map((item) => item.userCode)
      const list = items
        .filter((item) => !userCodes.includes(item.userCode))
        .map((item) => {
          return {
            userCode: item.userCode,
            userNo: item.userNo,
            userName: item.userName,
          }
        })
      this.formData.userList.push(...list)
    },
    addNotPassQty() {
      this.questionDialogVisible = true
    },
    questionConfirm(qualityIssuesTitle) {
      this.formData.issuesList.push({
        qualityIssuesTitle,
        notPassQty: 1,
      })
      this.formData.notPassQty += 1
      this.questionDialogVisible = false
      this.updateCheckedQty()
    },
    del(index) {
      this.formData.userList.splice(index, 1)
    },
    questionDel(index) {
      this.formData.issuesList.splice(index, 1)
      this.formData.notPassQty -= 1
      this.updateCheckedQty()
      this.updateRecheckQty()
    },
    updateCheckedQty() {
      this.formData.checkedQty = add(
        this.formData.notPassQty,
        this.formData.passQty
      )
    },
    questionUpdate({
      index,
      statusText,
      status,
      reworkBy,
      reworkByName,
      userNo,
    }) {
      const issuesList = this.formData.issuesList
      const issData = issuesList[index]
      issData.statusText = statusText
      issData.status = status
      issData.reworkByName = reworkByName
      issData.reworkBy = reworkBy
      issData.reworkByNo = userNo

      issuesList[index] = { ...issData }
      this.formData.issuesList = []
      this.formData.issuesList = [...issuesList]
      this.updateRecheckQty()
    },
    updateRecheckQty() {
      this.formData.recheckPassQty = this.formData.issuesList.filter(
        (item) => item.status == 'Y'
      ).length
      this.formData.recheckFailedQty = this.formData.issuesList.filter(
        (item) => item.status == 'X'
      ).length
    },
    addPassQty() {
      this.formData.passQty = add(1, this.formData.passQty)
      this.formData.checkedQty = add(
        this.formData.notPassQty,
        this.formData.passQty
      )
    },
    workShiftChange(e) {
      this.mrpWorkShiftData.forEach((item) => {
        if (item.value == e) {
          this.formData.workShiftName = item.label
        }
      })
    },
    async changeGoods() {
      await this.getData()
      this.$refs.goodsInfoRef.getData(this.formData.pendingGoodsCode)
      this.$emit('reload')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  padding: 0 20px 12px;
}
::v-deep .el-drawer__header {
  align-items: center;
  color: #141516;
  display: flex;
  margin-bottom: 12px;
  padding: 10px 20px 0;
}
::v-deep .text_color_balck {
  .el-input__inner {
    color: #0f0f0f;
    font-weight: 500;
    font-size: 18px;
  }
}
::v-deep .text_color_green {
  .el-input__inner {
    color: #2ba745;
    font-weight: 500;
    font-size: 18px;
  }
}
::v-deep .text_color_red {
  .el-input__inner {
    color: #f72713;
    font-weight: 500;
    font-size: 18px;
  }
}
</style>
